// extracted by mini-css-extract-plugin
module.exports = {"avatar_small":"avatarImage_avatar_small__3B1FZ","avatar_medium":"avatarImage_avatar_medium__2Nttl","avatar_big":"avatarImage_avatar_big__3mQeC"};